import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import {ROUTE} from 'containers/App/constants';
import {USER_TYPE} from 'containers/ManageUserPage/userType';

import Logo from 'assets/icons/logo.svg';
import Dashboard from 'assets/icons/dashboard.svg';
import Wisbit from 'assets/icons/wisbit.svg';
import Learner from 'assets/icons/no-coloured-learner.svg';
import Teacher from 'assets/icons/no-coloured-teacher.svg';
import Manager from 'assets/icons/no-coloured-manager.svg';
import Organization from 'assets/icons/no-coloured-organization.svg';

import Logout from 'assets/icons/logout.svg';
import i18n from 'i18next';

type Menu = {
  text: string;
  active: boolean;
  url: string;
  icon: string;
};

type LeftMenuProps = {
  type?: {
    id: string;
    serverAlias: string;
    text: string;
  };
  onLogout: () => void;
};

// Has to be a funciton to get the i18n data after the initialisation.
const GET_MENUS = () => [
  {
    text: i18n.t('leftMenu.organisationMenuTitle'),
    url: ROUTE.Organization,
    access: [USER_TYPE.SUPER_ADMIN.id],
    icon: Organization,
  },
  {
    text: i18n.t('leftMenu.administratorsMenuTitle'),
    url: ROUTE.Manager,
    access: [USER_TYPE.SUPER_ADMIN.id],
    icon: Manager,
  },
  {
    text: i18n.t('leftMenu.contentCreatorsMenuTitle'),
    url: ROUTE.ContentCreator,
    access: [USER_TYPE.ADMIN.id, USER_TYPE.SUPER_ADMIN.id],
    icon: Teacher,
  },
  {
    text: i18n.t('leftMenu.learnersMenuTitle'),
    url: ROUTE.Learner,
    access: [USER_TYPE.ADMIN.id, USER_TYPE.SUPER_ADMIN.id],
    icon: Learner,
  },
  {
    text: i18n.t('leftMenu.wisbitsMenuTitle'),
    url: ROUTE.Wisbit.Index,
    access: [USER_TYPE.CONTENT_CREATOR.id, USER_TYPE.ADMIN.id],
    icon: Wisbit,
  },
  {
    text: i18n.t('leftMenu.tagsMenuTitle'),
    url: ROUTE.Tags,
    access: [USER_TYPE.ADMIN.id, USER_TYPE.CONTENT_CREATOR.id],
    icon: Dashboard,
  },
];

function LeftMenu({type, onLogout}: LeftMenuProps) {
  const {pathname} = useLocation();

  const menus: Menu[] = [
    {
      text: i18n.t('leftMenu.dashboardMenuTitle'),
      url: ROUTE.Dashboard,
      active: pathname.includes(ROUTE.Dashboard),
      icon: Dashboard,
    },
    ...GET_MENUS()
      .filter(({access: menuRoles}) =>
        menuRoles.includes((type || USER_TYPE.CONTENT_CREATOR).id)
      )
      .map(({text, url, icon}) => ({
        text,
        url,
        active: pathname.includes(url),
        icon,
      })),
  ];

  return (
    <div className="w-1/6 min-w-60 px-4">
      <div className="flex items-center justify-center h-36">
        <img src={Logo} alt="logo" />
      </div>
      <div className="text-white font-bold">
        {menus.map(({text, active, url, icon}) => (
          <Link
            to={url}
            className={`h-12 flex items-center px-2 ${
              active
                ? 'bg-persian-indigo rounded-large flex justify-between'
                : ''
            }`}
            key={url}
          >
            <div className="flex items-center">
              <img src={icon} alt={text} />
              <span>{text}</span>
            </div>
            {active && <span className="bg-turquoise rounded-full w-2 h-2" />}
          </Link>
        ))}
        <div className="h-4" />
        <button
          onClick={onLogout}
          className="h-12 flex items-center justify-start px-2 font-bold"
        >
          <img src={Logout} alt="logout" />
          {i18n.t('leftMenu.logoutLabel')}
        </button>
      </div>
    </div>
  );
}

export default LeftMenu;
